import React from 'react'
import { useSelector } from 'react-redux'
import Image from 'antd/lib/image'
import { Link } from 'react-router-dom'
import { RootState } from '@store/store'
import { STATUS } from '@features/General'
import routes from '@utils/constants/routes'
import LogoIcon from '@assets/svg/logo.svg'
import styles from './index.scss'

export type LogoProps = {
    type?: 'white' | 'dark'
    showEventLogoIfExist?: boolean
    maxHeight?: any
    isLink?: boolean
}

const Logo = (props: LogoProps) => {
    const { type = 'dark', showEventLogoIfExist = true, maxHeight, isLink = false } = props
    const [logo, setLogo] = React.useState('')
    const [isLoading, setIsLoading] = React.useState(true)
    const { data: eventRecord, status: evnentStatus } = useSelector((state: RootState) => state.events.oneEvent)
    const { isMeetingHubEvent } = useSelector((state: RootState) => state.ui.companyProfile)
    const { data: domainData, status: subdomainStatus } = useSelector(
        (state: RootState) => state.events.oneEventByDomain
    )

    React.useEffect(() => {
        if (evnentStatus !== STATUS.RUNNING && subdomainStatus !== STATUS.RUNNING) {
            const branding = eventRecord?.branding?.[0] || eventRecord?.branding || domainData?.branding
            setLogo(showEventLogoIfExist ? branding?.logoImage || LogoIcon : LogoIcon)
            setIsLoading(false)
        } else {
            setLogo('')
            setIsLoading(true)
        }
    }, [showEventLogoIfExist, evnentStatus, subdomainStatus])
    const renderLogo = (
        <div className={styles.logo + ' ' + styles[type]} style={{ minHeight: maxHeight }}>
            {!isLoading && <Image preview={false} src={logo} fallback={LogoIcon} alt="Aladdin" style={{ maxHeight }} />}
            {isMeetingHubEvent && <span>Beta</span>}
        </div>
    )
    return <>{isLink ? <Link to={routes._}>{renderLogo}</Link> : <>{renderLogo}</>}</>
}

export default Logo
